import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import FriendLink from '../entities/friendlyLink'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';

interface FriendLinkState extends ListState<FriendLink> {
    editFriendLink: FriendLink;
}
class FriendLinkModule extends ListModule<FriendLinkState, any, FriendLink>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<FriendLink>(),
        loading: false,
        editFriendLink: new FriendLink(),
    }
    actions = {
        async getAll(context: ActionContext<FriendLinkState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FriendLink/GetAll', { params: payload.data });
            context.state.loading = false;            
            let page = reponse.data.result as PageResult<FriendLink>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },        
        async create(context: ActionContext<FriendLinkState, any>, payload: any) {
            await Ajax.post('/api/services/app/FriendLink/Create', payload.data);
        },
        async update(context: ActionContext<FriendLinkState, any>, payload: any) {
            await Ajax.put('/api/services/app/FriendLink/Update', payload.data);
        },
        async delete(context: ActionContext<FriendLinkState, any>, payload: any) {
            await Ajax.delete('/api/services/app/FriendLink/Delete?Id=' + payload.data.id);
        },        
        async get(context: ActionContext<FriendLinkState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FriendLink/Get?Id=' + payload.data.id);
            context.state.editFriendLink=reponse.data.result as FriendLink;
        }
    };
    mutations = {
        setCurrentPage(state: FriendLinkState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FriendLinkState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: FriendLinkState, friendLink: FriendLink) {
            state.editFriendLink = friendLink;
        }
    }
}
const friendLinkModule = new FriendLinkModule();
export default friendLinkModule;